import React from 'react'
import PropTypes from 'prop-types'
import { Slider, Arrow, CollectionCard } from '@tc-packages/tc-common'

export const CollectionSlider = ({
                                   products,
                                   sliderOptions = {},
                                   additionalClasses = '',
                                   containerClass = 'cardSlider_container container',
                                   id,
                                 }) => {
  const items = products.map((p) => <CollectionCard key={p.id} {...p} />)

  const settings = {
    arrows: true,
    prevArrow: <Arrow direction="prev" />,
    nextArrow: <Arrow direction="next" />,
    ...sliderOptions,
  }

  return (
    <div className={containerClass} id={id}>
      <Slider
        className={`cardSlider ${additionalClasses}`}
        items={items}
        {...settings}
      />
    </div>
  )
}

CollectionSlider.propTypes = {
  additionalClasses: PropTypes.string,
  containerClass: PropTypes.string,
  id: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  sliderOptions: PropTypes.object,
}

export default CollectionSlider
